/**
 * The timestamp at which DailyScape was removed.
 *
 * @see {@link https://secure.runescape.com/m=news/patch-notes-dailyscape-overhaul}
 * @internal
 */
export const DAILYSCAPE_REMOVAL_TIMESTAMP = Date.UTC(2_026, 2, 16, 13, 15);
